/** Pure helpers for solution-run screens: labels and status colours. */

import type { RunKind, RunProgressOut, RunStatusValue } from "@/shared/api/solutionRuns";

export const RUN_KIND_LABEL: Record<RunKind, string> = {
  translate: "Translate",
  qa: "Q&A",
  review: "Review",
  quality: "Quality",
  completeness: "eTMF completeness",
  doc_completeness: "Document completeness",
};

export const RUN_STATUS_COLOR: Record<RunStatusValue, string> = {
  queued: "gray",
  running: "blue",
  succeeded: "green",
  failed: "red",
};

export const RUN_STATUS_LABEL: Record<RunStatusValue, string> = {
  queued: "Queued",
  running: "Running",
  succeeded: "Succeeded",
  failed: "Failed",
};

/** 0–100; `null` when the total is not known yet (indeterminate). */
export function progressPercent(p: RunProgressOut): number | null {
  if (p.total <= 0) return null;
  return Math.min(100, Math.round((p.done / p.total) * 100));
}

export function formatUtc(value: string | null | undefined): string {
  if (!value) return "—";
  const d = new Date(value);
  return Number.isNaN(d.getTime())
    ? value
    : d.toISOString().replace("T", " ").slice(0, 16) + " UTC";
}
